import { render, staticRenderFns } from "./changed_file_icon.vue?vue&type=template&id=b635a8ee&"
import script from "./changed_file_icon.vue?vue&type=script&lang=js&"
export * from "./changed_file_icon.vue?vue&type=script&lang=js&"
import style0 from "./changed_file_icon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports